
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.23.758a.833.833 0 011.113-.084l.08.07 2.5 2.5c.3.3.323.773.069 1.1l-.07.079-2.916 2.916c-.3.3-.773.324-1.1.07l-.079-.07-1.831-1.83-2.259 2.364.053.076a5.418 5.418 0 01.818 3.922l-.048.24-.052.217a5.417 5.417 0 01-9.097 2.408 5.417 5.417 0 016.82-8.324l.205.139 2.891-2.89a.83.83 0 01.319-.2L15.23.759zM8.913 8.275a3.75 3.75 0 00-5.309 5.296 3.75 3.75 0 005.554-5.03l-.134-.152-.05-.062-.061-.052zm6.935-5.75l-1.699 1.778 1.269 1.268 1.737-1.738-1.307-1.307z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    